type Props = Pick<HTMLDivElement, "className"> & {
	children: React.ReactNode;
};

/**
 * Grid, Flex, Margin, Padding ...etc を定義するためのレイアウト。
 * 本来は上位レイヤーとしてパターンごとに定義することが望ましく感じるが、試験的に導入をしてみる。
 *
 * @param className {string | undefined}
 * @param children {React.ReactNode}
 * @example
 * ```tsx
 * <Layout className="grid grid-cols-2 gap-4">{children}</Layout>
 * ```
 */
export const Layout = ({ className, children }: Props) => {
	return <div className={className}>{children}</div>;
};
